import React from 'react';
import Data from './data';
import PropPage from 'pages/june-5/props/components/PropPage';
const Page = () => ( <PropPage data={Data}/>);
export default Page


// WEBPACK FOOTER //
// ./src/pages/june-5/props/data/71/page.js